<div class="card">
    <div class="cardError">
        <img class="logoError" src="assets/img/error.png">
        <p style="color: red; font-size: 20px; "><strong>Lo Sentimos</strong></p>
        <p style="font-size: 15px;">{{data}}</p>
        <button mat-raised-button color="warn" (click)="dismissSnackbar()">Cerrar</button>
    </div>
</div>
